import { Col, Row } from "react-bootstrap";
import { ESolarSystemType } from "../../../../shared/oversight-core/enums/solar-system-type ";
import MaterialIcon, {
  MtIcon,
} from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import styles from "./solar-system-type.module.scss";

interface IProps {
  item: {
    id: number;
    icon?: MtIcon;
    title: string;
    description: string;
    solarSystemType?: ESolarSystemType;
  };
  onSelect: () => void;
  isSelected?: boolean;
  isDarkMode: boolean;
}

const SolarSystemType = (props: IProps) => {
  const { item, onSelect, isSelected, isDarkMode = false } = props;

  return (
    <div
      className={`${styles.solarSystemTypeContainer} ${
        isSelected ? `bg-primary` : `bg-background-4`
      } ${
        isDarkMode && isSelected ? styles.borderDarkMode : ``
      } cursor-pointer p-4`}
      onClick={onSelect}
    >
      <Row className="justify-content-center">
        <Col className="col-auto text-center">
          <Row className="align-items-center">
            {item.icon && (
              <Col className="col-auto pe-0">
                <MaterialIcon
                  icon={item.icon}
                  color={
                    isSelected
                      ? `#ffffff`
                      : `var(--color-solar-system-type-title)`
                  }
                  size={18}
                  fill
                />
              </Col>
            )}
            <Col
              className={`${
                isSelected ? `text-white` : styles.title
              } font-weight-600 font-size-14 ps-2`}
            >
              {item.title}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col
          className={`${
            isSelected ? `text-white` : `solar-system-type-text`
          } text-center font-weight-400 font-size-12`}
        >
          {item.description}
        </Col>
      </Row>
    </div>
  );
};

export default SolarSystemType;
